import { getFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * WS-1063 Миграция файлов из Telegram для Desktop
 */
export const cloudFilesMigrationDesktop = getFeature('cloud-files-migration-desktop');

/**
 * CLOUDWEB-20682: [tgmig] Входные точки в миграцию на десктопе. Блок в сайдбаре
 */
export const cloudFilesMigrationDesktopSidebarLink =
    getFeature('cloud-files-migration-desktop-sidebar-link') || '/files_migration?from_app=cloud&enter_point=sider';

/**
 * Интервал поллинга данных из профиля
 */
export const profilePollingInterval: number = getFeature('profile-polling-interval') || 60_000;

interface CloudFilesMigrationUrlParam {
    url: string;
    currentPage: boolean;
}

interface CloudFilesMigrationUrls {
    relogin: CloudFilesMigrationUrlParam;
    restart: CloudFilesMigrationUrlParam;
}

export const cloudFilesMigrationUrls: CloudFilesMigrationUrls = getFeature('cloud-files-migration-urls') || {
    relogin: { url: '/files_migration', currentPage: false },
    restart: { url: '/files_migration', currentPage: false },
};

type TariffsSettings = {
    title: string;
    tariffsNumber: string;
    activeTab: string;
};

export const cloudFilesMigrationTariffs: TariffsSettings = getFeature('cloud-files-migration-tariffs');

export const cloudFilesMigrationModal = {
    title: cloudFilesMigrationTariffs.title || 'Память и другие функции с Mail Space',
    tarrifsNumber: cloudFilesMigrationTariffs.tariffsNumber || '54',
    activeTab: cloudFilesMigrationTariffs.activeTab || 'y',
};

export const TELEGRAM_WEB_START_MODAL_ID = 'telegram-web-start-modal';

export const TELEGRAM_WEB_START_MODAL_CONFIG = getFeature(`${TELEGRAM_WEB_START_MODAL_ID}-config`) || {
    showLimit: 3,
    closeLimit: 3,
    showInterval: 60 * 60 * 24 * 2,
};

export const cloudFilesMigrationDesktopStartModalLink =
    getFeature('cloud-files-migration-desktop-start-modal-link') || '/files_migration?from_app=cloud&enter_point=modal-with-start';
